import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/page4': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M248 504c-137 0-248-111-248-248s111-248 248-248c20.9 0 41.3 2.6 60.7 7.5l-266.4 376.5h205.7v112zM248 360.4h-149.4l149.4-213.6v213.6zM344 392h111.4c-26.9 41-65.7 73.5-111.4 92.7v-92.7zM401.4 253.8v16.7l-21.2-8.3zM381.1 308.3c5.9 0 8.2 4.7 8.2 10.6v10h-16.2v-7.7c0-6.6 1.3-12.9 8-12.9zM496 256c0 37.3-8.2 72.7-23 104.4h-129v-333.1c89.3 37.5 152 125.8 152 228.7zM360.4 143.6h68.2v-47.6h-13.9v32.6h-13.9v-29.6h-13.9v29.6h-12.7v-32.6h-13.9v47.6h0.1zM428.5 328.9h-26.5v-11c0-15.4-5.6-25.2-20.9-25.2-15.4 0-20.7 10.6-20.7 25.9v25.3h68.2v-15h-0.1zM428.5 225.9l-68.2 29.7v12.4l68.2 29.5v-16.6l-14.4-5.7v-26.5l14.4-5.9v-16.9zM423.7 157.4h-35.6v26.6h13.9v-12.2h11c8.6 15.8 1.3 35.3-18.6 35.3-22.5 0-28.3-25.3-15.5-37.7l-11.6-10.6c-16.2 17.5-12.2 63.9 27.1 63.9 34 0 44.7-35.9 29.3-65.3z'
      }
    ]
  }
})
